import PropTypes from 'prop-types';
import React from 'react';

import { illegalNameChars, sensorSubTypeToTitlePlural, GROUP_TYPES, sensorSubTypeToTitle } from './util/topic.js';

const FLOAT_TYPES = ["ABSOLUTE_HUMIDITY", "ACCELERATION", "AIR_FLOW", "AIR_PRESSURE", "ELECTRICAL_RESISTANCE", "ELECTRIC_FIELD_STRENGTH", "FLUX", "FREQUENCY", "HUMIDITY", "TEMPERATURE", "DEW_POINT", "DEW_DIFFERENCE"];
const ENERGY_TYPES = ["Current", "Voltage", "KWhTotal", "KWhSubtotal", "PowerW", "PowerVA", "LineFreq", "PowerVAR", "PhaseAngle", "PowerFactor", "CrestFactor", "ResidualCurrent", "ResidualCurrentAC","ResidualCurrentDC"];
const INLET_TYPES = ["PHASE", "SUM", "SINGLE", "CB", "BRANCH"];

export class ClassifierPicker extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            stages: {}
        };

        if (props.existingName) {
            this.state.stages[4] = {
                0: props.existingName
            };
        }
    }

    UNSAFE_componentWillMount() {
        const self = this;

        import(/* webpackChunkName: "react-table-6" */ 'react-table-6').then(({ default: _ }) => {
            self.setState({
                ReactTable: _
            });
        });
    }


    getDeviceData() {
        const data = [];
        const root = this.context.p.DS?.sensor;
        if (!root) {
            return [];
        }

        for (let uuid in root) {
            const device = root[uuid];
            data.push({uuid: uuid, name: device.name, type: device.type, vendor: device.vendor, location: device.location});
        }

        return data;
    }
    

    createRule = () => {
        const s = this.state.stages;
        if (!s || !s[5]?.[0]) {
            // TODO: error
            return;
        }

        const name = s[5]?.[0];
        const portType = s[3]?.[0];
        let rule;
        // Check if we will have an addition port type or dc group selector from stage 4
        function createFilter(key_op, value) {
            let [key, op] = key_op.split("_");
            key += '=';
            if (op === 'startswith') {
                value += '.*';
            } else if (op === 'endswith') {
                value = ".*" + value;
            } else if (op === 'contains') {
                value = ".*" + value + ".*";
            }
            return key + value;
        }
        let secondaryFilters = [];
        const stage4 = s[4];
        if (stage4 && stage4[0] !== "all") {
            if (stage4[0] === "name" && stage4[2]) {
                secondaryFilters.push(createFilter(stage4[1] || 'NAME_is', stage4[2]));
            }
        }

        // Build the rule
        if (s[1]?.[0] === "device") {
            const deviceType = s[2]?.[0];
            // Build a device rule
            rule = "sensor/";
            if (deviceType === "all_devices") {
                rule += "_/";
            } else if (deviceType === "all_type_devices" && s[2]?.[1]) {
                rule += "TYPE=" + s[2]?.[1] + "/";
            } else if (deviceType === "this_device" && s[2]?.[2]) {
                rule += s[2]?.[2] + "/";
            } else {
                // TODO: error
            }

            let portClassifier = "", topic;
            if (portType === "port_sensors") {
                rule += "s/";
                portClassifier = s[3]?.[3];
            } else if (portType === "port_outlets") {
                portClassifier = s[3]?.[1];
                rule += "o/";
            } else if (portType === "port_energy_meters" || portType === "port_inlets") {
                portClassifier = s[3]?.[2];
                rule += "i/";
            }
            if (portClassifier) {
                if (portClassifier.indexOf("|") !== -1) {
                    [topic, portClassifier] = portClassifier.split("|");
                    secondaryFilters.push(portClassifier);
                } else {
                    topic = portClassifier;
                }
                if (secondaryFilters.length) {
                    rule += secondaryFilters.join("&");
                } else {
                    rule += "_";
                }
                rule += "/" + topic;
                this.props.onComplete(rule, name);
                return;
            } else {
                // TODO: error
            }

        } else {
            const groupType = s[2]?.[0];
            secondaryFilters.push("TYPE=" + groupType);
            const value = s[3]?.[1] || s[3]?.[2];
            // Build a DC rule
            rule = "group/" + secondaryFilters.join("&") + "/" + value;
            this.props.onComplete(rule, name);
        }
    }

    render() {
        const self = this, t = this.context.t;

        if (!this.state.ReactTable) {
            return (
                <div className="wrapper devices">
                    <div className="loader-element">
                        <div className="loading loading-lg"></div>
                    </div>
                </div>
            );
        }

        // A local translation function, prefixing all translation keys with "thresholds.create_step_" for convenience
        function thrT(key, context) {
            return self.context.t("thresholds.create_step_" + key, Object.assign({
                this_item_type: self.props.thisItemType,
                one_new_item_type: self.props.oneNewItemType
            }, context ? context : {}));
        }

        function getStage2DeviceType() {
            const stage2 = self.state.stages?.[2];

            if (stage2 && stage2[0] === "all_type_devices" && stage2[1]) {
                return stage2[1];
            }
            if (stage2 && stage2[0] === "this_device" && stage2[2]) {
                return self.context.p.DS?.sensor?.[stage2[2]]?.type;
            }
        }

        /**
         * Check if we have a value for a certain stage
         * @param stage the stage to check for
         **/
        function hasStage(stage) {
            if (self.state.stages?.[1]?.[0] === "group") {
                if (stage === 2) {
                    return self.state.stages?.[2]?.[0];
                }

                if (stage === 3) {
                    if (self.state.stages?.[3]?.[0] === "value_energy") {
                        return self.state.stages?.[3]?.[1];
                    }
                    if (self.state.stages?.[3]?.[0] === "value_environment") {
                        return self.state.stages?.[3]?.[2];
                    }    
                }
            }
            if (stage === 5) {
                return self.state.stages?.[5]?.[0] && self.state.stages?.[5]?.[1];
            }

            if (stage === 4) {
                const mainFilter = self.state.stages?.[4]?.[0];
                if (mainFilter === "all") {
                    return true;
                }
                if (mainFilter === "name") {
                    // Check that name is valid
                    return self.state.stages?.[4]?.[2] && !self.state.stages?.[4]?.[2]?.match(illegalNameChars);
                }
            }

            if (stage === 3) {
                if (self.state.stages?.[3]?.[0] === "port_outlets") {
                    return self.state.stages?.[3]?.[1];
                }
                if (self.state.stages?.[3]?.[0] === "port_inlets" || self.state.stages?.[3]?.[0] === "port_energy_meters") {
                    return self.state.stages?.[3]?.[2];
                }
                if (self.state.stages?.[3]?.[0] === "port_sensors") {
                    return self.state.stages?.[3]?.[3];
                }
            }

            if (stage === 2) {
                const stage2 = self.state.stages?.[2];
                if (!stage2) {
                    return false;
                }
                // Stage 2 is completed for these conditions: all devices, devices of type + type selected
                return stage2[0] === "all_devices" || (stage2[0] === "all_type_devices" && stage2[1]) || (stage2[0] === "this_device" && stage2[2]);
            }
            return self.state.stages[stage];
        }

        /**
         * Set a value for a particular stage and part.
         * @param stage
         * @param part
         * @param value value to set
         * @param cb Callback to be called with the newStages info to override over things
         */
        function setStage(stage, part, value, cb) {
            self.setState((state) => {
                const newStages = {};
                // Copy "lower" and current stage info
                for (let i = 1; i <= stage; i++) {
                    newStages[i] = state.stages[i];
                }

                if (!newStages[stage]) {
                    newStages[stage] = [];
                }

                // Replace current stage info for part
                newStages[stage][part] = value;

                if (cb) {
                    cb(newStages);
                }

                return {stages: newStages};
            });
        }

        function setStageFromEv(stage, part, ev) {
            let cb;
            if (stage === 2 && part === 1 && ev.target.value === "COOLING") {
                cb = (newStages) => {
                    newStages[3] = ["s"];
                };
            }
            setStage(stage, part, ev.target.value, cb);
        }

        function createStageButton(stage, part, value) {
            const currentValue = self.state.stages[stage]?.[part];
            const className = (currentValue === value) ? "rule-button btn btn-primary" : "rule-button btn";
            return (
                <button key={stage + "_" + part + "_" + value} onClick={setStage.bind(self, stage, part, value, null)} className={className}>{thrT(stage + "_" + value)}</button>
            );
        }

        function translationSort (translation, a, b) {
            if (translation[a] < translation[b]) {
                return -1;
            }

            if (translation[a] > translation[b]) {
                return 1;
            }

            return 0;
        }

        function createOptions(header, types, translations, part, requiredKey, disabledCheck) {
            const options = [];
            options.push(
                <option value="" key={requiredKey + "h"}>{thrT(header)}</option>
            );

            for (let key of types) {
                options.push(
                    <option key={requiredKey + "_" + key} value={key}>{translations[key]}</option>
                );
            }


            return (
                <select value={self.state.stages?.[3]?.[part]} disabled={disabledCheck(self.state.stages?.[3]?.[0])} onChange={setStageFromEv.bind(self, 3, part)} className="form-select rule-select">
                    { options }
                </select>
            );
        }

        /**
         * Create a combined button and text entry
         * @param {*} stage current stage
         * @param {*} types types that are shown in the dropdown
         * @param {*} translations to translate the types
         * @param {*} buttonPart part where button sets its value
         * @param {*} part part to write text entry into
         * @param {*} disabledCheck called to see if it's disabled, called with current buttonValue of stage
         */
        function createEntry(stage, types, translations, buttonPart, part, disabledCheck) {
            const requiredKey = "thr-lab-" + stage + "-" + part;
            
            const currentText = self.state.stages[stage]?.[part] || "";
            const options = [];

            for (let key of types) {
                options.push(
                    <option key={requiredKey + "_" + key} value={key}>{translations[key]}</option>
                );
            }
            const disabled = disabledCheck(self.state.stages?.[stage]?.[buttonPart]);
            let textClassName = "form-input rule-input";
            if (!disabled && !currentText) {
                textClassName += " ";
            }

            const illegalCharsFound = currentText.match(illegalNameChars);

            if (illegalCharsFound) {
                textClassName += " is-error";
            }

            return (
                <>
                    <select value={self.state.stages?.[stage]?.[buttonPart]} onChange={setStageFromEv.bind(self, stage, buttonPart)} className="form-select rule-select">
                        { options }
                    </select>
                    { !disabled && (
                        <input value={currentText} disabled={disabled} className={textClassName} onChange={setStageFromEv.bind(self, stage, part)} type="text" placeholder={t("general.name")}></input>
                    )}
                    { !disabled && illegalCharsFound && (
                        <p className="form-input-hint">{t("details_configuration.button_error_illegal_chars", {chars: illegalCharsFound.join(", ")})}</p>
                    )}
                </>
            );
        }

        let stage2 = null, stage3 = null, stage4 = null, stage5 = null;

        if (hasStage(1)) {
            if (this.state.stages[1][0] === "device") {
                let types = (
                    <select value={self.state.stages?.[2]?.[1]} disabled={self.state.stages?.[2]?.[0] !== "all_type_devices"} onChange={setStageFromEv.bind(self, 2, 1)} className="form-select rule-select">
                        <option value="">{thrT("2_all_type_devices_header")}</option>
                        <option value="PDU">{t("device_types.pdu")}</option>
                        <option value="PANELMETER">{t("device_types.panelmeter")}</option>
                        <option value="SENSORBOX">{t("device_types.sensorbox")}</option>
                        <option value="COOLING">{t("device_types.cooling")}</option>
                        <option value="UPS">{t("device_types.ups")}</option>
                    </select>
                );

                let deviceList = null;
                if (this.state.stages?.[2]?.[0] === "this_device") {
                    const data = self.getDeviceData();
                    deviceList = (
                        <this.state.ReactTable
                            data={data}
                            getTdProps={(state, rowInfo, column, instance) => {
                                const columnStyle = (rowInfo?.original && rowInfo?.original?.uuid === self.state.stages?.[2]?.[2]) ? { background: "green" } : {};
                                return {
                                    style: columnStyle,
                                    onClick: (e, handleOriginal) => {
                                        setStage(2, 2, rowInfo?.original?.uuid, (newStages) => {
                                            if (rowInfo?.original?.type === "COOLING") {
                                                newStages[3] = ["s"];
                                            }
                                        });

                                        if (handleOriginal) {
                                            handleOriginal();
                                        }
                                    }
                                };
                            }}
                            columns={[
                                {
                                    Header: "Name",
                                    accessor: "name"
                                },
                                {
                                    Header: "Type",
                                    accessor: "type"
                                },
                                {
                                    Header: "Vendor",
                                    accessor: "vendor"
                                }
                            ]}
                            defaultSorted={[
                                {
                                    id: "name",
                                    desc: true
                                }
                            ]}
                            defaultPageSize={10}
                            filterable
                            defaultFilterMethod={(filter, row) => {
                                return row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase()) !== -1;
                            }}

                            className="-striped -highlight rule-reacttable"
                        />
                    );
                }
                stage2 = (
                    <div className="card">
                        <div className="card-header">{thrT("2_device_title")}</div>
                        <div className="card-body">
                            { createStageButton(2, 0, "all_devices") }<br />
                            <div className="input-group">
                                { createStageButton(2, 0, "all_type_devices") }<br />
                                { types }
                            </div>
                            { createStageButton(2, 0, "this_device") }
                            { deviceList }
                        </div>
                    </div>
                )

                if (hasStage(2)) {
                    const stage2Type = getStage2DeviceType();

                    let translations = {};
                    let floatTypes = [];
                    for (let key of FLOAT_TYPES) { 
                        const classifier = "val|TYPE=" + key;
                        floatTypes.push(classifier);
                        translations[classifier] = t("topic_titles." + key.toLowerCase());
                    }

                    let energyTranslations = {};
                    for (let key of ENERGY_TYPES) { 
                        energyTranslations[key] = t("topic_titles." + key.toLowerCase());
                    }

                    // Add translations for energy topics that are not shared by inlets and outlets
                    energyTranslations["Current"] = t("topic_titles.current");

                    // Duplicate energy types and add outlet and inlet specific options
                    const outletTypes = ENERGY_TYPES.slice(), inletTypes = ENERGY_TYPES.slice();
                    if (outletTypes.indexOf("Current") === -1) {
                        outletTypes.push("Current");
                    }

                    // Add all classifier matched inlet Current types
                    for (const inletType of INLET_TYPES) {
                        inletTypes.push("Current|TYPE=" + inletType);
                        energyTranslations["Current|TYPE=" + inletType] = energyTranslations["Current"] + " / " + t("topic_titles." + inletType?.toLowerCase());
                    }

                    floatTypes.sort(translationSort.bind(this, translations));

                    inletTypes.sort(translationSort.bind(this, energyTranslations));
                    outletTypes.sort(translationSort.bind(this, energyTranslations));

                    let outletSelector, inletSelector;
                    if (stage2Type !== "SENSORBOX" && stage2Type !== "COOLING") {
                        outletSelector = (
                            <div className="input-group">
                                { createStageButton(3, 0, "port_outlets") }<br />
                                { createOptions("3_port_energy_type_header", outletTypes, energyTranslations, 1, "port_outlets", (current) => current !== "port_outlets") }
                            </div>
                        );
                    }

                    if (stage2Type !== "COOLING") {
                        inletSelector = (
                            <div className="input-group">
                                { createStageButton(3, 0, stage2Type === "SENSORBOX" ? "port_energy_meters" : "port_inlets") }<br />
                                { createOptions("3_port_energy_type_header", inletTypes, energyTranslations, 2, "port_outlets", (current) => (current !== "port_energy_meters" && current !== "port_inlets")) }
                            </div>
                        );
                    }

                    stage3 = (
                        <div className="card">
                            <div className="card-header">{thrT("3_port_type_title")}</div>
                            <div className="card-body">
                                { outletSelector }
                                { inletSelector }
                                <div className="input-group">
                                    { createStageButton(3, 0, "port_sensors") }
                                    { createOptions("3_port_sensor_type_header", floatTypes, translations, 3, "port_sensors", (current) => current !== "port_sensors") }
                                </div>
                            </div>
                        </div>
                    );
                }
            } else {
                // DC items. User has to select a type
                let typeNodes = [];
                for (let type of GROUP_TYPES) {
                    const currentValue = self.state.stages[2]?.[0];
                    const className = (currentValue === type) ? "rule-button btn btn-primary" : "rule-button btn";
                    
                    typeNodes.push((
                        <>
                            <button key={"2_0_" + type} onClick={setStage.bind(self, 2, 0, type, null)} className={className}>{sensorSubTypeToTitlePlural[type]}</button><br key={"br_2_0_" + type} />
                        </>
                    ));
                }
                stage2 = (
                    <div className="card">
                        <div className="card-header">{thrT("2_group_title")}</div>
                        <div className="card-body">
                            { typeNodes }
                        </div>
                    </div>
                )

                if (hasStage(2)) {
                    // Sensor types need to select which kind of sensor
                    let translations = {};
                    for (let key of FLOAT_TYPES) { 
                        translations[key] = t("topic_titles." + key.toLowerCase());
                    }

                    let energyTypes = ["Current", "Voltage", "KWhTotal", "ResidualCurrent", "PowerVA", "PowerW", "PowerVAR"];
                    const floatTypes = FLOAT_TYPES.slice();

                    let energyTranslations = {};
                    for (let key of energyTypes) { 
                        energyTranslations[key] = t("topic_titles." + key.toLowerCase());
                    }
                    energyTypes = energyTypes.concat(["L1", "L2", "L3"]);
                    energyTranslations["L1"] = energyTranslations.Current + " L1";
                    energyTranslations["L2"] = energyTranslations.Current + " L2";
                    energyTranslations["L3"] = energyTranslations.Current + " L3";

                    floatTypes.sort(translationSort.bind(this, translations));
                    energyTypes.sort(translationSort.bind(this, energyTranslations));

                    stage3 = (
                        <div className="card">
                            <div className="card-header">{thrT("3_port_type_title")}</div>
                            <div className="card-body">
                                <div className="input-group">
                                    { createStageButton(3, 0, "value_energy") }
                                    { createOptions("3_port_energy_type_header", energyTypes, energyTranslations, 1, "value_energy", (current) => current !== "value_energy") }
                                </div>
                                <div className="input-group">
                                    { createStageButton(3, 0, "value_environment") }
                                    { createOptions("3_port_sensor_type_header", floatTypes, translations, 2, "value_environment", (current) => current !== "value_environment") }
                                </div>
                            </div>
                        </div>
                    );
                }

            }
        }
        if (hasStage(3)) {
            const options = ["NAME_is", "NAME_startswith", "NAME_endswith", "NAME_contains"];
            const translations = {
                "NAME_is": thrT("4_name_is"),
                "NAME_startswith": thrT("4_name_startswith"),
                "NAME_endswith": thrT("4_name_endswith"),
                "NAME_contains": thrT("4_name_contains"),
            };
            const cb = function (current) {
                return self.state.stages?.[4]?.[0] != "name";
            };
            // Data source name gets derived from different stages for devices and DC
            let dataSource;
            if (this.state.stages[1][0] === "device") {
                const lastStageToDataSource = {
                    'port_outlets': "Outlet",
                    'port_inlets': "Inlet",
                    'port_sensors': "Sensor",
                    'port_energy_meters': "Meter"
                };
                dataSource = lastStageToDataSource[self.state.stages[3][0]];
            } else {
                // DC, take from stage 2
                dataSource = sensorSubTypeToTitle[self.state.stages[2][0]];
            }

            const okClassName = (self.state.stages[4]?.[10] === "ok") ? "rule-button btn btn-primary" : "rule-button btn";
            // Show "filter port by" options
            stage4 = (
                <div className="card">
                    <div className="card-header">{thrT("4_title", { 'data_source': dataSource } )}</div>
                    <div className="card-body">
                        { createStageButton(4, 0, "all") }<br />
                        <div className="input-group">
                            { createStageButton(4, 0, "name") }
                            { createEntry(4, options, translations, 1, 2, cb) }<br/>
                        </div>
                    </div>
                </div>
            );
        }

        if (hasStage(3) && hasStage(4)) {
            stage5 = (
                <div className="card">
                    <div className="card-header">{thrT("5_title")}</div>
                    <div className="card-body">
                        <div className="form-group">
                            <label className="form-label rule-label" htmlFor="thr-name">{thrT("5_name")}</label>
                            <input className="form-input rule-input" onChange={setStageFromEv.bind(self, 5, 0)} type="text" id="thr-name" placeholder={t("general.name")} disabled={this.props.existingName}></input>
                        </div>
                        <button disabled={!this.state.stages?.[5]?.[0]} onClick={self.createRule} className="rule-button btn">{this.props.saveButtonText}</button>
                    </div>
                </div>
            );
        }

        return (
            <div className="main">
                <div className="content overview reports">
                    <div className="columns">
                        <div className="card">
                            <div className="card-header">{thrT("1_title")}</div>
                            <div className="card-body">
                                { createStageButton(1, 0, "device") }<br />
                                { createStageButton(1, 0, "group") }<br />
                            </div>
                        </div>

                        { stage2 }
                        { stage3 }
                        { stage4 }
                        { stage5 }
                    </div>
                </div>
            </div>
            );
    }
}

ClassifierPicker.propTypes = {
    onComplete: PropTypes.func,
    existingName: PropTypes.bool,
    oneNewItemType: PropTypes.string,
    thisItemType: PropTypes.string,
    saveButtonText: PropTypes.string
};
